import React from "react";
import {
  Container,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import {
  getAllCookies,
  getCookieTypes,
} from "../../components/layout/cookies/CookieFunctions";
import { titleCase } from "../../components/utilities/UtilityFunctions";

const cookieTypes = getCookieTypes();
const cookies = getAllCookies();

export default function CookieNotice() {
  return (
    <Container sx={{ p: 1, pt: 2, pb: 2 }} maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        Cookie Notice
      </Typography>
      <Typography variant="body1" paragraph>
        The technologies we use for this automatic data collection of Technical
        Data may include Cookies (or browser cookies). Our Cookie Notice
        provides details on how we use cookies and your choices about cookies. A
        cookie is a small file placed on the hard drive of your computer.
        Cookies enable the site’s or service provider’s systems to recognize
        your browser and capture and remember certain information regarding your
        visit to the Website such as: your IP address; the domain from which you
        accessed the Website; the date, time and duration of your visit; and the
        pages you visited.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>How we Use Cookies:</strong> We use cookies to: authenticate
        users, personalize and optimize users’ browsing experience, provide
        security measures, perform analysis, and to track consent for cookies.
      </Typography>
      <Typography variant="body1" paragraph>
        <ul
          style={{
            display: "block",
            marginBlockStart: "4px",
            marginBlockEnd: "4px",
            marginInlineStart: "0px",
            marginInlineEnd: "0px",
            paddingInlineStart: "40px",
          }}
        >
          {cookieTypes.map((cookieType) => (
            <li key={cookieType.id}>
              <div>
                <strong>{cookieType.name}</strong>: {cookieType.description}
              </div>
            </li>
          ))}
        </ul>
      </Typography>
      <Typography variant="body1" paragraph>
        We may contract third-party service providers to assist us in better
        understanding our site visitors. These service providers are not
        permitted to use the information collected on our behalf except to help
        us conduct and improve our business. We use Google Analytics to analyze
        use of our Services. The information gathered is used to create reports
        about the use of our Services. For more information on Google Analytics,
        please refer to{" "}
        <Link
          href="https://policies.google.com/technologies/partner-sites"
          target="_Blank"
        >
          Google’s Privacy Policy
        </Link>
        .
      </Typography>
      <Typography variant="body1" paragraph>
        The table below lists the individual cookies that our Services use:
      </Typography>
      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table
          size="small"
          aria-label="The table below lists the individual cookies that our Services use"
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">Domain</TableCell>
              <TableCell align="center">Cookie Name</TableCell>
              <TableCell align="center">Cookie Type</TableCell>
              <TableCell align="center">Purpose</TableCell>
              <TableCell align="center">Expiration</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cookies.map((cookie) => (
              <TableRow
                key={cookie.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {cookie.domain}
                </TableCell>
                <TableCell>{cookie.name}</TableCell>
                <TableCell>{titleCase(cookie.type)}</TableCell>
                <TableCell>{titleCase(cookie.purpose)}</TableCell>
                <TableCell>{cookie.expiration}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="body1" paragraph>
        <strong>Your Choices About Cookies.</strong> You can set your browser to
        refuse all or some browser cookies, or to alert you when websites set or
        access cookies. However, if you select this setting, you may be unable
        to access certain parts of our Website. Unless you have adjusted your
        browser setting so that it will refuse cookies, our system will issue
        cookies when you direct your browser to our Website.
      </Typography>
    </Container>
  );
}
